import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "payment-setup" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Get Paid for your Time")
], -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "subText" }, "Opt creates a standard link for you to share with the public through your email signature, website, social media and more. Don't worry, you can create unlimited unique links for specific meeting types or people.")
], -1 /* HOISTED */)
const _hoisted_4 = { class: "rate-container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "rate-title" }, "Your standard meeting rate", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "rate-subtext" }, "for a 30 min meeting", -1 /* HOISTED */)
const _hoisted_7 = { class: "payment-container" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "symbol" }, "$", -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "editAmount" }, "Tap Amount to Edit", -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "bottom-description" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "subText" }, "We've started it at $50 for 30 min, but you can edit this value above or change it anytime in your account settings or in each custom meeting invite")
], -1 /* HOISTED */)
const _hoisted_11 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          class: "paymentAmount",
          type: "number",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.amount) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, $setup.amount]
        ])
      ]),
      _hoisted_9
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: "outline save-amount",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateDefaultRate()))
      }, "Save Amount")
    ])
  ]))
}